import type { ApprovalStatus } from '../generated-types';
import { initialState } from './signingInitialState';
import { Action, Actions, SigningFlowState } from './signingTypes';

const shouldShowSigningFlow = (approvalStatus: ApprovalStatus) =>
    ['CREATED', 'REJECTED', 'UNKNOWN'].includes(approvalStatus);

const reducer = (state: SigningFlowState, action: Action): SigningFlowState => {
    switch (action.type) {
        case Actions.SIGN_START:
            return {
                ...state,
                signingOperationPending: true,
            };
        case Actions.SIGN_SUCCESS:
            return {
                ...state,
                signingStatus: action.result.status,
                redirectUri: action.result.returnUrl,
                dynamicLinkId: action.result.dynamicLinkId,
                showSigningFlow: shouldShowSigningFlow(action.result.status),
                signingOperationPending: false,
                bankIDOnly: action.result.bankIdOnly,
            };

        case Actions.SIGN_ERROR:
            return {
                ...state,
                signingOperationPending: false,
                dynamicLinkId: undefined,
                signingError: action.error,
                showSigningFlow: false,
            };

        case Actions.CLEAR_ERROR:
            return {
                ...state,
                signingError: undefined,
            };

        case Actions.RESET:
            return {
                ...initialState,
            };
        case Actions.CANCEL_SIGNING:
            return {
                ...state,
                signingStatus: undefined,
                signingOperationPending: false,
                signingError: undefined,
                showSigningFlow: false,
            };
        case Actions.CANCEL:
            return {
                ...state,
                signingStatus: 'CANCELLED',
                signingOperationPending: true, // TODO: should be set to false?
                signingError: undefined,
                showSigningFlow: false,
            };
        case Actions.COMPLETE_SIGNING:
            return {
                ...state,
                signingStatus: action.status,
                signingOperationPending: false,
                showSigningFlow: shouldShowSigningFlow(action.status),
            };
        case Actions.UPDATE_STATUS:
            return {
                ...state,
                signingStatus: action.status,
                signingOperationPending: action.status === 'CREATED',
                showSigningFlow: shouldShowSigningFlow(action.status),
            };
        case Actions.PAYMENT_CHECKED:
            return {
                ...state,
                signingStatus: action.status,
                signingOperationPending: false,
                showSigningFlow: false,
            };
        default:
            return state;
    }
};

const withLogger = (state: SigningFlowState, action: Action): SigningFlowState => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log(
            '%cSigningState',
            'color: green; font-weight: bold',
            state,
            Array.from(Object.values(Actions))[action.type],
            'new state',
            newState,
        );
    }
    return newState;
};

export default withLogger;
